//
// forms/industry-select-functionality.js
//
// - Called on load: if an industry dropdown is present, and functionality is turned on
//   (by a template, via data-attrs) change redirect based on selection.
//

import { path_base }    from '../bw-paths';

export default function run_industry_select_functionality(el_form) {
  const form_id                    = el_form.dataset.formId;
  const [ industry_dropdown ]      = el_form.querySelectorAll("select.c-select__native[name='Industry']");
  const [ use_case_dropdown ]      = el_form.querySelectorAll("select.c-select__native[name='routingUseCase']");
  const [ industry_logos_wrapper ] = document.querySelectorAll('[data-js-c-form-industry-dropdown-controller="' + form_id + '"]');
  const initial_redirect           = el_form.dataset.redirect;

  if (!industry_dropdown || !industry_logos_wrapper) {
    // for now, turn everything off if logos wrapper doesn't have the
    // correct attrs on it
    return false;
  }

  const url_map = {
    'agency': {
      'redirect': 'confirmation/demo-agencies/',
      'logos':    'agencies',
    },
    'cpg': {
      'redirect': 'confirmation/demo-cpg/',
      'logos':    'cpg',
    },
    'financial-services': {
      'redirect': 'confirmation/demo-financial-services/',
      'logos':    null,
    },
    'pharmaceuticals-and-healthcare': {
      'redirect': 'confirmation/demo-pharma-healthcare/',
      'logos':     null,
    },
    'media-and-entertainment': {
      'redirect': 'confirmation/demo-media-entertainment/',
      'logos':    'media-and-entertainment',
    },
    'retail': {
      'redirect': 'confirmation/demo-retail/',
      'logos':    'retail',
    },
    'technology': {
      'redirect': 'confirmation/demo-technology/',
      'logos':    'technology',
    },
    'other': {
      'redirect': 'confirmation/demo/',
      'logos':    null,
    },
  };

  // for testing
  // const select_options = Array.from(industry_dropdown.options).map((item) => {
  //   return item.innerHTML.trim().replace(/\s+/g, '-').toLowerCase().replace(/&amp;/g, 'and').replace(/,/g, '');
  // });
  // console.log(select_options);

  function change_logos(industry) {
    const logos            = industry_logos_wrapper.querySelectorAll('[data-js-c-form-industry-dropdown-controller-logo]');
    const [ default_logo ] = industry_logos_wrapper.querySelectorAll('[data-js-c-form-industry-dropdown-controller-default-logo]');
    if (!logos) return false;

    // Hide all logos
    Array.from(logos).forEach((logo) => {
      logo.classList.add('dn');
    });

    if (url_map[industry]) {
      const [ logo_to_show ] = industry_logos_wrapper.querySelectorAll('[data-js-c-form-industry-dropdown-controller-logo-name="' + url_map[industry]['logos'] + '"]');

      if (logo_to_show) {
        default_logo.classList.add('dn');
        logo_to_show.classList.remove('dn');
      }
      else {
        default_logo.classList.remove('dn');
      }
    }
    else {
      default_logo.classList.remove('dn');
    }
  }

  function uc_select_onchange() {
    if (use_case_dropdown.selectedIndex > 0) {
    
      // Set the redirect
      // -------------------------------------

      if (use_case_dropdown.value == "Social Media Management") {
        const redirect           = path_base() + 'confirmation/social-media-management/';
        const base64_redirect    = window.btoa(redirect);
        el_form.dataset.redirect = base64_redirect;
      } 
      else {
        cb_select_onchange(); // revert to industry redirect logic
      }
    }    
  }

  function cb_select_onchange() {
    let industry = null;

    if (industry_dropdown.selectedIndex > 0) {
      industry = industry_dropdown.value
        .trim()
        .replace(/\s+/g, '-')
        .toLowerCase()
        .replace(/&amp;/g, 'and')
        .replace(/,/g, '');
      
      // Set the redirect if SMM is not already selected as Use Case
      // -------------------------------------

      if (use_case_dropdown && use_case_dropdown.value !== "Social Media Management") {
        if (url_map[industry]) {
          const redirect           = path_base() + url_map[industry]['redirect'];
          const base64_redirect    = window.btoa(redirect);
          el_form.dataset.redirect = base64_redirect;
        }
        else {
          el_form.dataset.redirect = initial_redirect;
        }
      }
      
      // Set client logos
      // -------------------------------------

      if (industry_logos_wrapper) {
        change_logos(industry);
      }
    }     
  }

  if (use_case_dropdown) {
    use_case_dropdown.addEventListener('change', uc_select_onchange);
  }
  
  industry_dropdown.addEventListener('change', cb_select_onchange);
  
  // run on kick off, in-case prefill etc has already set
  uc_select_onchange();
  cb_select_onchange();
}

